import styles from "./FJMainColorSwitch.module.less";
import React, {Component, createRef} from "react";
import FJSwitch from "fj-components/FJSwitch";
import classNames from 'classnames';
import FJUtil from "../../util/FJUtil";
import FJLocalStore from "../../store/FJLocalStore";

class FJMainColorSwitch extends Component{

	constructor(props) {
		super(props);

		this.switchRef = createRef();
	}


	componentDidMount() {
		FJUtil.allTooltip('u-tooltip-bottom', 'bottom')
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.active !== prevProps.active) {
			FJUtil.allTooltip('u-tooltip-bottom', 'bottom')
		}
	}

	onSwitchClick = (active) => {
		this.props.onChange(active)
		FJUtil.toggleTooltip(this.switchRef.current, false)
	}

	render() {
		const {active} = this.props;
    const Tips = {
      'turn-off': FJLocalStore._('turn-off'),
      'turn-on': FJLocalStore._('turn-on'),
    }
    const tips = active ? Tips['turn-off'] : Tips['turn-on']

		return (
			<div className={classNames(styles.box, 'u-tooltip-bottom')} tooltip={tips} ref={this.switchRef}>
				<FJSwitch active={active}
									onChange={this.onSwitchClick}
									activeClassName={styles.switch_active}
									className={styles.switch_bg}
				/>
			</div>
		);
	}

}

export default FJMainColorSwitch;